export function mergeConfig(config, defaultConfig) {
  let res = {}
  for (let i in defaultConfig) {
    res[i] = i in config ? config[i] : defaultConfig[i]
  }
  return res
}

export function toBool(val) {
  if (typeof val === 'string') {
    return ['false', 'no', 'off', '0', ''].indexOf(val.toLowerCase()) === -1
  }
  return Boolean(val)
}

export function toInt(val, _default) {
  let res = parseInt(val)
  if (isNaN(res)) {
    res = _default
  }
  return res
}

export function toFloat(val, _default) {
  let res = parseFloat(val)
  if (isNaN(res)) {
    res = _default
  }
  return res
}

export function formatCurrency(price) {
  return new Intl.NumberFormat('zh-CN', {
    minimumFractionDigits: price < 100 ? 2 : 0
  }).format(price)
}

export function getTimeTextHourMin(date) {
  let hour = date.getHours()
  let min = `00${date.getMinutes()}`.slice(-2)
  return `${hour}:${min}`
}

export function getUuid4Hex() {
  let chars = []
  for (let i = 0; i < 32; i++) {
    let char = Math.floor(Math.random() * 16).toString(16)
    chars.push(char)
  }
  return chars.join('')
}

export function objectToQuery(obj) {
  let query = ''
  for (let key in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(key)) {
      let value = obj[key]
      query += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`
    }
  }
  query = query.slice(0, -1) // 去除最后一个多余的&
  return query
}


export function debounce(fun, delay) {
  let deferTimer = null
  return function(args) {
    // 获取函数的作用域和变量
    let [that, _args] = [this, args]
    // 每次事件被触发，都会清除当前的timeer，然后重写设置超时调用
    if (deferTimer) {
      clearTimeout(deferTimer)
      deferTimer = null
    }
    deferTimer = setTimeout(function() {
      fun.call(that, _args)
    }, delay)
  }
}
